export const STAGE_LABEL = { ap: "Aperitivo", pr: "Primer plato", po: "Postre" };
export const STAGE_LIMIT = 2;

export const emptySelection = () => ({ ap: [], pr: [], po: [] });

export const isSelectedIn = (selection, id, stage) =>
    Array.isArray(selection?.[stage]) && selection[stage].includes(id);

// Devuelve {next, errorMsg?}
export function toggleStageSelection(selection, id, stage) {
    const cur = selection?.[stage] || [];
    const exists = cur.includes(id);

    if (exists) {
        return { next: { ...selection, [stage]: cur.filter((x) => x !== id) } };
    }

    if (cur.length >= STAGE_LIMIT) {
        return { next: selection, errorMsg: `${STAGE_LABEL[stage]}: máximo ${STAGE_LIMIT} vinos` };
    }

    return { next: { ...selection, [stage]: [...cur, id] } };
}

export function buildPrintUrl(selection, autoPrint) {
    const qs = new URLSearchParams();
    if (autoPrint) qs.set("auto", "1");
    if (selection?.ap?.length) qs.set("apIds", selection.ap.join(","));
    if (selection?.pr?.length) qs.set("prIds", selection.pr.join(","));
    if (selection?.po?.length) qs.set("poIds", selection.po.join(","));
    return `/print/vinos?${qs.toString()}`;
}
